<template>
  <div class="container">
    <div class="head">
      登录
    </div>
    <van-field
      v-model="phone"
      type="number"
      clearable
      label=""
      maxlength="11"
      placeholder="请输入手机号"
      @input="hanldePhoneChange"
    />
    <van-field v-model="code" label="" placeholder="请输入验证码" maxlength="4">
      <template #button>
        <van-button
          size="small"
          :disabled="sendDisabled"
          type="primary"
          class="ver_btn"
          @click="handleSendCode"
        >{{ isSending ? number + "s" : "获取验证码" }}</van-button
        >
      </template>
    </van-field>
    <div class="btn">
      <van-button @click="login" type="primary">登录</van-button>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import { sendCheckCodeByIdentity, mobileLogin } from "@/api/centerLogin";
import { mapMutations } from "vuex";
export default {
  name: "canteenMLogin",
  data() {
    return {
      phone: "", // 手机号
      code: "", // 验证码
      number: 60, // 倒计时
      sendDisabled: true,
      isSending: false,
      timer: null
    };
  },
  created() {
    document.title="站长中心"
  },
  mounted() {
  },
  methods: {
    ...mapMutations(["updateUser"]),
    hanldePhoneChange(val) {
      if (/1\d{10}/.test(val)) {
        this.sendDisabled = false;
      } else {
        this.sendDisabled = true;
      }
    },
    handleSendCode() {
      if (this.isSending) return;
      this.isSending = true;
      this.sendDisabled = true;
      this.timer = window.setInterval(() => {
        if (this.number - 1 == 0) {
          this.number = 60;
          this.isSending = false;
          this.sendDisabled = false;
          window.clearInterval(this.timer);
        } else {
          this.number = this.number - 1;
        }
      }, 1000);
      sendCheckCodeByIdentity({ mobile: this.phone })
        .then(res => {
          if (res.code == 200) {
            Toast("验证码发送成功！");
          } else {
            Toast(res.message || "验证码发送失败！");
            this.sendDisabled = false;
            this.isSending = false;
            if (this.timer) {
              window.clearInterval(this.timer);
            }
          }
        })
        .catch(() => {
          Toast("验证码发送失败！");
          this.isSending = false;
          this.sendDisabled = false;
          if (this.timer) {
            window.clearInterval(this.timer);
          }
        });
    },
    login() {
      if (!this.phone.trim()) {
        Toast("请输入手机号！");
        return;
      }
      if (!this.code.trim()) {
        Toast("请输入验证码！");
        return;
      }
      if (!/1\d{10}/.test(this.phone)) {
        Toast("请输入正确的手机号！");
        return;
      }
      mobileLogin({
        platform: "node_center",
        mobile: this.phone,
        code: this.code.trim()
      })
        .then(res => {
          if (res.code == 200) {
            Toast({ message: "登录成功！", duration: 1000 });
            this.updateUser({
              token: res.data.loginToken,
              userId: res.data.userBaseId
            });
            setTimeout(() => {
              this.$router.push("/stationCenter/centerHome");
            }, 1000);
          } else {
            Toast(res.message || "登录失败，请重试！");
          }
        })
        .catch(() => {
          Toast("登录失败，请重试！");
        });
    }
  }
};
</script>
<style scoped lang="less">
.container {
  padding: 100px 16px 0;
  text-align: center;
  font-size: 24px;
  .head {
    margin-bottom: 50px;
  }
  .ver_btn {
    border-radius: 10px;
    background-color: #f39800;
    border-color: #f39800;
    width: 90px;
    font-size: 14px;
  }
  .ver_btn.van-button--disabled {
    background-color: #999;
    border-color: #999;
  }
  .btn {
    margin-top: 20px;

    .van-button--normal {
      width: 100%;
      font-size: 18px;
      background-color: #f39800;
      border-color: #f39800;
    }
  }
}
</style>
